import { render } from "./BatchLoaderModal.vue?vue&type=template&id=11438cce&ts=true"
import script from "./BatchLoaderModal.vue?vue&type=script&lang=ts"
export * from "./BatchLoaderModal.vue?vue&type=script&lang=ts"

import "./BatchLoaderModal.vue?vue&type=style&index=0&id=11438cce&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__